import http from "../http";
import Service from "../../Service";

/**
 * @type ProductService
 */
export default class ProductService extends Service {

    get_products(for_id, page=1, search = null){
        const params = new URLSearchParams({
            page
        });

        if (search) {
            params.append('search', search);
        }
        return http.get(`providers/${for_id}/produtos-fornecedor?${params.toString()}`, {
            headers: this.getHeaders()
        });
    }

    export_products_report(for_id, search = null) {
        const params = new URLSearchParams();
        if (search) {
            params.append('search', search);
        }
        return http.get(
            `providers/${for_id}/produtos-fornecedor/excel?${params.toString()}`,
            {
                headers: this.getHeaders(),
                responseType: "blob",
            }
        );
    }
    
}
